import { Color } from "@repo/app-types/constants/colors";
import {
  checkIsInterviewDataExtractionCustomFieldName,
  checkIsInterviewSectionAssessmentCustomFieldName,
} from "@repo/app-types/entities/customField";
import { Pill } from "@repo/ui/Pills/pill";
import { Size } from "@repo/ui/helpers/helpers";
import type { FC } from "react";
import { LabeledAssessmentScore } from "../../insights/assessmentScore.js";

interface InterviewAssessmentRatingProps {
  rating: any;
  fieldName: string | undefined;
}

export const InterviewAssessmentRating: FC<InterviewAssessmentRatingProps> = ({
  rating,
  fieldName,
}) => {
  // Handle interview section assessment field - we expect a 1-5 number score
  if (checkIsInterviewSectionAssessmentCustomFieldName(fieldName)) {
    // If the rating is a number or can be converted to a number, use LabeledAssessmentScore
    if (rating !== null && rating !== undefined) {
      const numericRating = Number(rating);
      if (!isNaN(numericRating)) {
        return <LabeledAssessmentScore score={numericRating} />;
      }
    }
  }

  // Handle boolean values
  if (typeof rating === "boolean") {
    return (
      <Pill
        label={rating ? "Yes" : "No"}
        size={Size.SMALL}
        color={rating ? Color.Green : Color.Red}
      />
    );
  }

  // Currently only used for CEFR language level.
  if (typeof rating === "string") {
    return <Pill label={rating} size={Size.SMALL} color={Color.Gray} />;
  }

  if (typeof rating === "number") {
    if (checkIsInterviewDataExtractionCustomFieldName(fieldName)) {
      return (
        <Pill label={rating.toString()} size={Size.SMALL} color={Color.Gray} />
      );
    }

    return <LabeledAssessmentScore score={rating} />;
  }

  return <Pill label="Unknown" size={Size.SMALL} color={Color.Gray} />;
};
